import { render, staticRenderFns } from "./MobileAuthenticationHeader.vue?vue&type=template&id=6706da08&scoped=true&"
import script from "./MobileAuthenticationHeader.vue?vue&type=script&lang=js&"
export * from "./MobileAuthenticationHeader.vue?vue&type=script&lang=js&"
import style0 from "./MobileAuthenticationHeader.vue?vue&type=style&index=0&id=6706da08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6706da08",
  null
  
)

export default component.exports